import './global/animation'
import './global/scroll-to'

import './components/appointment'
import './components/carousel'
import './components/masonry'
import './components/stage'
